module.exports = __webpack_public_path__ + "assets/game-type-video-conversation.d09a4ba0.svg";